import React from 'react';
import { db} from './Firebase/firebase';
import { useState } from 'react';

import loading_gif from './assets/loading.gif';
import logo from './assets/usku_logo.png';

function Invoice () {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formState, setFormState] = useState({});
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [orderDetails, setOrderDetails] = useState(null);

    function handleChange(e) {
        e.persist();
        setFormState(formState => ({...formState, [e.target.name]: e.target.value}))
    }

    async function handleSubmit(e) {
        setLoading(true);
        console.log('Submit button clicked');
        e.persist();
        const { referenceId, name } = formState;

        try {
            await db.collection('swift').doc(referenceId)
                .get()
                .then((doc) => {
                    const data = doc.data();
                    const isOwner = validateOwner(name, data.metadata);
                    if (isOwner) {
                        setOrderDetails(data);
                        setFormSubmitted(true);
                        setError("");
                    } else {
                        setError("Name and order mismatch");
                    }
                    setLoading(false);
                })
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    }

    function validateOwner(givenName, metadata) {

        if (givenName.toLowerCase() === metadata.name.toLowerCase() || givenName.toLowerCase() === metadata.payerName.toLowerCase()) {
            return true;
        }
        return false;
    }

    if (loading) {
        return(<img src={loading_gif}/>)
    } else if (!formSubmitted) {
        return (
            <div>
                <div className="form">
                    <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <h1>Get your Invoice</h1>
                    <div className="input-container">
                        <label htmlFor="name">Name</label>
                        <input type="text" onChange={handleChange} name="name" id="name"/>
                    </div>
                    <div className="input-container">
                        <label htmlFor="referenceId">Reference ID</label>
                        <input type="text" onChange={handleChange} id="referenceId" name="referenceId"/>
                    </div>
                    {error === null ? <p></p> : <p style={{textAlign: "center", color: "red"}}>{error}</p>}
                    <button className="btn" style={{textAlign: "center"}} onClick={handleSubmit}>Login</button>
                    </div>
                </div>
            </div>
        )
    } else if (formSubmitted) {
        return (
            <div className="form-container">
                <img className="usku-logo" src={logo} alt="Usku" />
                <h1>{ orderDetails.order_pin }</h1>
                <h4>Your Invoice URL</h4>
                <a href={ orderDetails.invoice_url }>{ orderDetails.invoice_url }</a>
                { !orderDetails.invoice_url && <p>Your invoice has not been generated for now. It will be generated once your order has been accepted by one of our deliverers. If a problem arises, please contact Usku for more information</p> }
                <br/>
                { !orderDetails.metadata.prePurchase && <p>Please also transfer your budget for the shopping that has not been prepurchased to <br/>(Pay ID: usku@uskutech.com)</p> }
            </div>
        )
    }


}

export default Invoice;